export const hasStructuredText = data => {
  let result = false;

  if (
    data &&
    data.value &&
    data.value.document.children.find(
      child =>
        child &&
        child.children &&
        child.children.length > 0 &&
        child.children[0].value !== '',
    )
  ) {
    result = true;
  }

  return result;
};
